import { render, staticRenderFns } from "./PoiTocCard.vue?vue&type=template&id=77c2ee70&"
import script from "./PoiTocCard.vue?vue&type=script&lang=js&"
export * from "./PoiTocCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports